const cookieKey = '.token_expiration_min'
const timeoutMin = 500000

export default {
  props: {
    timerInterval: 0,
    expTime: timeoutMin
  },
  beforeDestroy(self) {    
    if (self.timerInterval > 0) {
      clearInterval(self.timerInterval)
    }
  },
  getTimeoutMinutes: function () {
    return timeoutMin
  },
  setCookiesTime: function (self) {
    self.timerInterval = setInterval(() => {
      let expirationCookieValue = self.$cookies.get(cookieKey)
      if (expirationCookieValue !== undefined) {
        self.expTime = parseInt(expirationCookieValue) - 1
        self.$cookies.set(cookieKey, self.expTime, null, '/')
      }
      
      if (self.expTime === undefined || self.expTime <= 0) {
        clearTimeout(self.timerInterval);
        self.$router.push('/logout');
      }
    }, 1000 * 60)
  },
  checkCookieExpiredInLogin: function (self) {
    if (self.$cookies.isKey(cookieKey) &&
      self.$cookies.get(cookieKey) !== undefined &&
      parseInt(self.$cookies.get(cookieKey)) < 0) {
       //remove is for some reason not working, resetting so this msg is not displayed again
      self.$cookies.set(cookieKey, 0, null, '/')
      self.$cookies.remove(cookieKey) 
      return true
    }
   
    return false
  } 
} 



// WEBPACK FOOTER //
// ./src/shared/tokenexpiration.js